export default __webpack_public_path__ + "static/media/file_type_arrow.9acf2d26.svg";